import React from 'react'
import {Box, Text, Stack, Container, Flex} from '../../vanilla'
import {SlotComponent} from '../../types/ui'
import {InfoCardCmsContent, InfoCardListCmsContent} from '../../types/cms'
import {CmsImage} from './cms-image'
import {CTAButton} from '../../vanilla/components/CTAButton'
import {Carousel} from '../carousel'

interface InfoCardProps {
  content:InfoCardCmsContent
  imagesListLength: number
  index: number
  dividerLines: boolean
}
const InfoCard = ({
  content,
  dividerLines,
  imagesListLength,
  index
}: InfoCardProps) => {
  return (
    <Stack
      gap="16px"
      width="full"
      flex="1"
      borderRight={dividerLines && index < imagesListLength - 1 ? ['0px', '1px'] : '0px'}
      style={{borderRightColor: '#e4e4e4'}}
      alignItems="center"
      paddingX={['0px', '12px']}
      paddingBottom={['20px', '0px']}
      key={`${content.image?.imageLink}--${index}`}
    >
      <Stack alignItems="center" gap="16px">
        {content.image?.image?.images && (
          <Box
            borderRadius={content.addImageCircle ? 'full' : undefined}
            bg={content.addImageCircle ? 'white' : 'transparent'}
            alignSelf="center"
            height="100px"
            width="100px"
            display="inline-flex"
            alignItems="center"
            justifyContent="center"
          >
            <CmsImage
              images={content.image?.image?.images}
              imageLink={content.image?.imageLink}
              isStaticImage={content.imageType}
              height="auto"
              width="full"
              maxHeight={content.addImageCircle ? '64px' : '100px'}
              maxWidth={content.addImageCircle ? '84px' : undefined}
              display="inline-block"
              overflow="hidden"
              verticalAlign="middle"
              alignSelf="center"
            />
          </Box>
        )}
        <Stack gap={['4px', '2px']} paddingTop={['4px', '0px']} paddingBottom={['12px', '0px']}>
          <Text
            variant="heading1"
            style={{color: content.text?.headlineTextColor?.color}}
            textAlign="center"
            textDecoration="none"
          >
            {content.text?.headline}
          </Text>
          <Text
            variant="text3"
            textAlign="center"
            alignSelf="center"
            color="gray800"
            textDecoration="none"
          >
            {content.text?.body}
          </Text>
        </Stack>
      </Stack>
      {content.cta?.ctaText && (
        <Flex textAlign="center" marginTop="auto">
          <CTAButton cta={content.cta} />
        </Flex>
      )}
    </Stack>
  )
}

export const InfoCardList: SlotComponent<InfoCardListCmsContent> = ({content}) => {
  const imagesList = content?.infoCardsList

  return (
    <Container
      width="full"
      position="relative"
      overflow="hidden"
      style={{backgroundColor: content?.backgroundColor?.color}}
      paddingX={['12px', '0px']}
    >
      <Flex
        align="center"
        display={['none', 'flex']}
        justifyContent="space-around"
        paddingY="12px"
        alignItems="stretch"
        height="full"
        gap="0px"
      >
        {imagesList?.map((card, index) => {
          return (
            <InfoCard
              content={card}
              dividerLines={content?.dividerLines}
              imagesListLength={imagesList?.length}
              index={index}
              key={`info-card-${index}`}
            />
          )
        })}
      </Flex>
      <Box display={['block', 'none']} paddingY="12px">
        {imagesList ? (
            <Carousel
            loop={false}
            itemsPerSide={{desktop: 1, mobile: 1, tablet: 1}}
            controlsPosition="bottom"
            controlConfig={{
              activeDotColor: 'accent0',
              arrowsBgColor: 'gray600',
              arrowsColor: 'white',
              showArrows: {mobile: false, desktop: true, tablet: true},
            }}
          >
              {imagesList.map((card, index) => {
                return (
                  <InfoCard
                    content={card}
                    dividerLines={content?.dividerLines}
                    imagesListLength={imagesList?.length}
                    index={index}
                    key={`carousel-info-card-${index}`}
                  />
                )
              })}
          </Carousel>
        ) : null}
      </Box>
    </Container>
  )
}
